import { Constants } from './constants';
import { Injectable } from '@angular/core';
import { SelectService } from './select-service';
import * as CryptoJS from 'crypto-js';
import { DatePipe } from '@angular/common';
import { FormControlName } from '@angular/forms';

declare function showJSToolTip(tagNameAttr: string): any;
declare function hideJSToolTip(tagNameAttr: string): any;

@Injectable({
    providedIn: 'root'
})
export class Utils {

    defaultSelectOption = { value: this.constants.BLANK, text: this.constants.DEFAULT_SELECT_OPTION_LABEL };

    private initialFieldValue: string = this.constants.BLANK;

    constructor(private constants: Constants) {
    }

    isEmpty(value: any) {
        return (value === undefined || value === null || value === this.constants.BLANK);
    }

    // showToolTip(tagNameAttr: string){
    //     showJSToolTip(tagNameAttr);
    // }

    // hideToolTip(tagNameAttr: string){
    //     hideJSToolTip(tagNameAttr);
    // }

    encryptString(plainString: string) {
        const key = CryptoJS.PBKDF2(this.constants.ENCRYPT_DECRYPT_MASTER_PASSWORD, this.constants.ENCRYPT_DECRYPT_MASTER_SALT, { keySize: 4, iterations: 1 });
        const encryptedString = CryptoJS.AES.encrypt(plainString, key, { iv: CryptoJS.enc.Utf8.parse(this.constants.ENCRYPT_DECRYPT_MASTER_KEY), padding: CryptoJS.pad.Pkcs7, mode: CryptoJS.mode.CBC });
        return encryptedString.toString();
    }

    decryptString(encryptedString: string) {
        const key = CryptoJS.PBKDF2(this.constants.ENCRYPT_DECRYPT_MASTER_PASSWORD, this.constants.ENCRYPT_DECRYPT_MASTER_SALT, { keySize: 4, iterations: 1 });
        const decryptedString = CryptoJS.AES.decrypt(encryptedString, key, { iv: CryptoJS.enc.Utf8.parse(this.constants.ENCRYPT_DECRYPT_MASTER_KEY), padding: CryptoJS.pad.Pkcs7, mode: CryptoJS.mode.CBC });
        const plainString = decryptedString.toString(CryptoJS.enc.Utf8);
        return plainString;
    }

    getMonthsArray() {
        const monthsList = [{ value: this.constants.BLANK, text: 'MM' }];
        monthsList.push({ value: '01', text: 'Jan' });
        monthsList.push({ value: '02', text: 'Feb' });
        monthsList.push({ value: '03', text: 'Mar' });
        monthsList.push({ value: '04', text: 'Apr' });
        monthsList.push({ value: '05', text: 'May' });
        monthsList.push({ value: '06', text: 'Jun' });
        monthsList.push({ value: '07', text: 'Jul' });
        monthsList.push({ value: '08', text: 'Aug' });
        monthsList.push({ value: '09', text: 'Sep' });
        monthsList.push({ value: '10', text: 'Oct' });
        monthsList.push({ value: '11', text: 'Nov' });
        monthsList.push({ value: '12', text: 'Dec' });
        return monthsList;
    }

    fetchIntTelOptionsObject(allowDropdown: boolean) {
        const mobileNumberOptionsObject = { initialCountry: 'ng', preferredCountries: [], separateDialCode: true, autoPlaceholder: this.constants.BLANK, allowDropdown: allowDropdown, formatOnDisplay: false, utilsScript: '/assets/js/utils.js' };

        return mobileNumberOptionsObject;
    }

    setMobileNumberFields(countryInfoObject: {}, formObject: {}, fieldsArray: any[]) {
        formObject[fieldsArray[0]] = countryInfoObject['iso2'];
        formObject[fieldsArray[1]] = '+' + countryInfoObject['dialCode'];
    }

    checkHasMatValueChanged(isOpened: boolean, formObject: {}, fieldName: string) {
        if (isOpened === true) {
            this.initialFieldValue = formObject[fieldName];
            return;
        }

        const currentFieldValue = formObject[fieldName];

        if (this.initialFieldValue === currentFieldValue) {
            formObject['hasFieldValueChanged'] = this.constants.FALSE;
        } else {
            formObject['hasFieldValueChanged'] = this.constants.TRUE;
        }
    }

    storePassportTypes(passportSelectService: SelectService): void {
        const passportTypeList = [this.defaultSelectOption];
        passportTypeList.push({ value: this.constants.STANDARD, text: 'Standard' });
        // passportTypeList.push({value: this.constants.DIPLOMATIC, text: 'Diplomatic'})
        // passportTypeList.push({value: this.constants.OFFICIAL, text: 'Official'})
        passportSelectService.setSelectOptions(passportTypeList);
    }

    getFlooredDate(givenDate: Date) {
        givenDate.setHours(0, 0, 0, 0);
        return givenDate;
    }

    getCeiledDate(givenDate: Date) {
        givenDate.setHours(23, 59, 59, 999);
        return givenDate;
    }

    addDays(givenDate: Date, days: number): void {
        givenDate.setDate(givenDate.getDate() + days);
    }

    getJSDate(date: string) {
        const dateArray = date.split('/');
        const requiredDate = dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2];
        return new Date(requiredDate);
    }

    validateCalendarYear(formGroupControlObject: FormControlName, dateValue: string): void {
        const formGroupControlValueArray = dateValue.split("/");

        const requestedYear = formGroupControlValueArray[2];
        if (requestedYear.length !== 4) {
            formGroupControlObject.control.setErrors({ hasError: true, errorMessage: "Invalid calendar year" });
            return;
        }

        formGroupControlObject.control.setErrors(null);
    }

    validateName(formGroupControlObject: FormControlName, givenLabel: string, givenValue: string): void {
        if (this.isEmpty(givenValue) === true) {
            return;
        }

        const pattern = new RegExp(/[`!@#$%^&*()_+\=\[\]{};:"\\|,<>\/?~]/);

        const isValid = pattern.test(givenValue) === false;

        if (isValid === false) {
            // formGroupControlObject.control.setErrors({ hasError: true, errorMessage: givenLabel + ' is not valid. Make sure it should not contain special characters.' });
            formGroupControlObject.control.setErrors({ hasError: true, errorMessage: givenLabel + ' is not valid.' });
        }
    }

    checkIsMobileDeviceUsed(): boolean {
        const deviceDetails = navigator.userAgent;
        const mobileDeviceExpression = /android|iphone|kindle|ipad/i;
        return mobileDeviceExpression.test(deviceDetails);
    }

}
